import React from "react";
import FilterBox from "../../../Utils/FilterBox/FilterBox"

function Filter(props) {
	
    const { setPageParams } = props

    let filterTypes = {
        client_document_number: {
            type: "brazilian_document_numbers",
            disabled: false,
            validation:true,
            validation_rule: {type: "multiple_equal", values:[14,18]},
            description: "CPF/CNPJ"
        },
        operation_date: {
            type: "date",
            disabled: false,
            validation:false,
            validation_rule: null,
            description: "Data"
        },
        operation_id: {
            type: "string",
            disabled: false,
            validation:false,
            validation_rule: null,
            description: "Id da Operação"
          },
        operation_status: {
            type: "enum",
            enumList: [
                ["Esperando Processamento", "created"],
                ["Processada", "executed"],
                ["Cancelada", "cancelled"]
            ],
            disabled: false,
            validation:false,
            validation_rule: null,
            description: "Status da Operação"
          },
        analysis_status: {
            type: "enum",
            enumList: [
                ["Aprovado Manualmente", "manually_approved"],
                ["Reprovado Manualmente", "manually_reproved"],
                ["Aprovado Automaticamente", "automatically_approved"],
                ["Reprovado Automaticamente", "automatically_reproved"],
                ["Em Análise Manual", "in_analysis_manual"],
                ["Aprovado por tempo", "approved_by_time"]
            ],
            disabled: false,
            validation:false,
            description: "Status da Análise"
        }
    }

    return (
        <FilterBox 
            setPageParams={setPageParams}
            filterTypes={filterTypes}
            local_storage_object_preffix={props.local_storage_object_preffix}
        />
    )

}

export default Filter